import React from 'react';
import { Wrapper } from './styled';
import '@common/assets/ckeditor5-content.css';

interface PropsType {
	html: string;
}

function Description({ html = '' }: PropsType) {
	return (
		<Wrapper
			dangerouslySetInnerHTML={{ __html: html }}
			className="ck-content"
		/>
	);
}

export default Description;
